import axiosConfig from '../axiosConfig';

export default {
	/* 
        POST    /api/v1/login
    */
	login(email, password) {
		return axiosConfig.post('/login', { email, password });
	},

	/* 
        POST    /api/v1/refresh
    */
	refresh(token) {
		return axiosConfig.post('/refresh', {}, { 
            headers: { 
                Authorization: `Bearer ${token}` 
            } 
        });
	},

	/* 
        POST    /api/v1/user/change-password
    */
	changePassword(currentPassword, newPassword) {
		return axiosConfig.post('/user/change-password', { currentPassword, newPassword });
	},

	/* 
        POST    /api/v1/forgot-password
    */
	forgotPassword(email) {
		return axiosConfig.post('/forgot-password', { email });
	},

	/* 
        POST    /api/v1/reset-password
    */
	resetPassword(data) {
		return axiosConfig.post('/reset-password', data);
	},
};
